module.exports = __webpack_public_path__ + "img/naukri.1e62f374.svg";